import React, { useEffect, useState } from 'react';
import Headers from '../components/Header';
import { FaCheckCircle } from 'react-icons/fa'; // Importing checkmark icon from react-icons
import NumberFlow from '@number-flow/react'; // Use the default export
import LogoSection from './LogoSection';
import Footer from './Footer'
import Weinclude from '../components/Weinclude'
import { useNavigate } from 'react-router-dom';
import DuoIcon from '@mui/icons-material/Duo';


const Subscription = () => {

  const [plans, setPlans] = useState([]); // State to store subscription plans
  const [isLoading, setIsLoading] = useState(true); // State to handle loading
  const [error, setError] = useState(null); // State to handle errors
  const navigate = useNavigate();

  const mainContentMap = {
    "Trial plan": "Explore the basics of our lead distribution system.",
    "Startup Plan": "Perfect for startups to begin managing leads efficiently.",
    "Growth Plan": "Scale your lead workflows with advanced features.",
    "Enterprise Plan": "Full-featured solution for large organizations."
  };



  useEffect(() => {
    const fetchPlans = async () => {
      // const conuntyid = sessionStorage.getItem('conuntyid')
      const serviceid = parseInt(sessionStorage.getItem('serviceid'), 10) // 5
      try {
        // const response = await fetch(`https://verse.blaccdot.com/ldsbackendindia/masters/subscription/all/${conuntyid}`);
        const response = await fetch(`https://stage.apicanada.blaccdot.com/masters/subscription/categorybased/2`);
        if (!response.ok) {
          throw new Error('Failed to fetch plans');
        }
        const data = await response.json();
        const subscriptionMasters = data?.data?.subscriptionmasters || [];

        const formattedPlans = subscriptionMasters.map((plan, index) => ({
          id: plan._id,
          subscriptionmasterId: plan.subscriptionmasterId,
          title: plan.title,
          monthlyPrice: plan.monthAmount,
          annualPrice: plan.anualAmount,
          currency: plan.currency,
          taxAmount: plan.taxAmount,
          description: `${plan.creditpoints}`,
          features: plan.textcontent ? Object.values(plan.textcontent) : [],
          highlighted: index === 1,
          mainContent: mainContentMap[plan.title] || "A powerful lead management solution."
        }));
        setPlans(formattedPlans);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handleRediract = (plan) => {
    sessionStorage.setItem("subscriptionID", plan.subscriptionmasterId);
    sessionStorage.setItem('planTitle', plan.title)
    sessionStorage.setItem('planAmount', plan.monthlyPrice)
    sessionStorage.setItem('plantax', plan.taxAmount)
    sessionStorage.setItem('planTitle', plan.title)
    sessionStorage.setItem('countrycode', plan.currency)
    sessionStorage.setItem('credit', plan.description);
    navigate('/signup');
    // navigate('/payment');
  };

  const handleCustomFetch = async () => {
    const formID = sessionStorage.getItem('finalFormID')
    const payload = {
      user_type: "custom"
    }
    try {
      const response = await fetch(`https://euctostaging.com/lmsca/api/businessinitialform/update/${formID}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload)
      });

      const result = await response.json()
      navigate('/appointment');
    } catch (error) {
      console.log('error', error)
    }
  }


  return (
    <>
      <Headers />
      <div className="pricing-container">
        <h1 className="pricing-title">Plans That Fit Your Business</h1>
        <p className="pricing-subtitle">
          From startups to enterprises, find the right solution to boost your business growth.
        </p>

        {/* <button onClick={handleCustomFetch} style={{ marginBottom: '20px' }} className="button-21">
           <DuoIcon style={{ fontSize: 'larger', marginRight: '9px' }} /> Customized Plan
        </button> */}

        <div className="pricing-cards">
          {plans.length > 0 ? (
            <>
              {plans.map((plan) => (
                <div
                  key={plan.subscriptionmasterId}
                  className={`pricing-card ${plan.highlighted ? "highlighted" : ""}`}
                >
                  {plan.highlighted && (
                    <span className="badgeHigh">MOST POPULAR</span>
                  )}

                  <div className="plan-header">
                    <h2 className="plan-title">{plan.title}</h2>
                    <span className="plan-subtitle">
                      {plan.mainContent}
                    </span>
                  </div>

                  <div className="pricing-details">
                    <div className="price-wrapper">
                      <NumberFlow
                        value={plan.monthlyPrice}
                        duration={1000}
                        format="currency"
                        className="price-amount"
                      />
                      <span className="currency">{plan.currency || ""}</span>
                    </div>
                    <span className="tax-info">+ Taxes</span>
                    <p className="credit-info">
                      {plan.description} credit included
                    </p>
                  </div>

                  <ul className="feature-list">
                    {plan.features.length > 0 ? (
                      plan.features.map((feature, idx) => (
                        <li key={idx}>
                          <FaCheckCircle className="feature-icon" />
                          <span className="feature-text">{feature}</span>
                        </li>
                      ))
                    ) : (
                      <li>No features available</li>
                    )}
                  </ul>

                  <button
                    onClick={() => handleRediract(plan)}
                    className={`choose-plan-button ${plan.highlighted ? "highlighted-button" : ""
                      }`}
                  >
                    Choose {plan.title}
                  </button>
                </div>
              ))}

              <div className="pricing-card custom-plan-card">
                <div className="plan-header">
                  <h2 className="plan-title">Custom Plan</h2>
                  <span className="plan-subtitle">
                    Custom solution for large teams
                  </span>
                </div>

                <div className="pricing-details">
                  <div className="custom-price">Custom Plan</div>
                  <span className="tax-info">+ Taxes</span>
                  <p className="credit-info">Unlimited credits included</p>
                </div>

                <ul className="feature-list">
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">For movers who want more volume</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Dedicated account support</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Choose your monthly lead quantity</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Service Area Customization</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Lead Type Selection</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Dedicated Account Support</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Billing Flexibility</span>
                  </li>
                  <li>
                    <FaCheckCircle className="feature-icon" />
                    <span className="feature-text">Make it own</span>
                  </li>
                </ul>

                <button onClick={handleCustomFetch} className="choose-plan-button">
                  Contact Sales
                </button>
              </div>
            </>
          ) : (
            !isLoading && <p className="no-plans">No plans available</p>
          )}
        </div>
      </div>
      {/* <>
        <LogoSection />
      </> */}
      <>
        <Weinclude />
      </>
      <>
        <Footer />
      </>

    </>
  );
};

export default Subscription;


